import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { palette } from '../../themes/theme';

interface FollowupChipsProps {
    followups: string[];
    onSelect: (text: string) => void;
    disabled?: boolean;
}

const FollowupChips: React.FC<FollowupChipsProps> = ({ followups, onSelect, disabled }) => {
    if (followups.length === 0) return null;

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {followups.map((text, i) => (
                <Chip
                    key={i}
                    label={text}
                    onClick={() => onSelect(text)}
                    disabled={disabled}
                    sx={{
                        height: 'auto',
                        py: '0.5rem',
                        px: '0.3rem',
                        backgroundColor: palette.background.cream,
                        color: palette.brand.gold,
                        border: `1px solid ${palette.brand.gold}`,
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '14px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        '& .MuiChip-label': {
                            whiteSpace: 'normal',
                            lineHeight: 1.4,
                        },
                        '&:hover': {
                            backgroundColor: palette.brand.gold,
                            color: '#fff',
                        },
                    }}
                />
            ))}
        </Box>
    );
};

export default FollowupChips;
